/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Header.css';

import { IndexLink } from 'react-router';
import { Link } from 'react-router';
import Navigation from '../Navigation';
import window from 'window-or-global';
import $ from 'jquery';

@withStyles(s)
export default class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            scroll: false,
            triggerClick: false,
        };

        this.StickyHeader = this.StickyHeader.bind(this);
        this.ClickMobileTrigger = this.ClickMobileTrigger.bind(this);
        this.ClickSubMenu = this.ClickSubMenu.bind(this);
    }

    
    componentDidMount(){
        const trigger = this.refs.trigger;
        window.addEventListener('scroll', this.StickyHeader);
        trigger.addEventListener('animationend', this.ClickMobileTrigger);
       
    }

    componentWillUnmount(){
        const trigger = this.refs.trigger;
        window.removeEventListener('scroll', this.StickyHeader);
        trigger.removeEventListener('animationend', this.ClickMobileTrigger);
    }


    StickyHeader(e){

        var y = window.scrollY;

        if(y > 65){
            this.setState({ scroll: true })
        }
        if(y < 65){
            this.setState({ scroll: false })
        }
        
    }

    ClickMobileTrigger(e){

        this.setState({triggerClick: false})
        
    }

    ClickSubMenu(e){

        $('.wrapSubMenu').slideToggle('fast');
        
    }

    render(){
        const classHeader = this.state.scroll ? 'header smaller' : 'header';
        const classCollapse = this.state.collapse ? 'wrapSubMenu active' : 'wrapSubMenu';
        const active = this.state.triggerClick;
        const flipOutX = this.state.triggerClick;

        return (
            <div className={s.root}>
                <header id="header" className={`${classHeader}`}>
                    <div className={`container`}>
                        <div className={`wrapLogo`}>
                            <div className={`logo`}>
                                <IndexLink to="/" onClick={() => this.setState({triggerClick: false})}>
                                    <img src={require('./logo/logo-blanc.svg')} alt="Logo" className={`logoImg`} />
                                </IndexLink>
                            </div>
                            <div className={`textLogo`}>
                                <IndexLink to="/">
                                    <span>Prolifik</span>
                                </IndexLink>
                            </div>
                        </div>
                        <div className={`wrapMobileTrigger`}>
                            <ul onClick={() => this.setState({triggerClick: true})} ref="trigger" className={`mobileTrigger ${active ? 'active' : ''}`}>
                                <li className={`bar first`}></li>
                                <li className={`bar middle`}></li>
                                <li className={`bar last`}></li>
                            </ul>
                        </div>
                        <div className={`wrapNavSocial`}>
                            <nav>
                                <ul>
                                    <li><a href="https://www.facebook.com/Agence-Prolifik-158443841246997/?fref=ts" target="_blank" className={`iconHeader iconFacebook fa fa-facebook flipOutX`}></a></li>
                                    <li><a href="mailto:info@agenceprolifik.ca" className={`iconHeader iconEnvelope fa fa-envelope-o`}></a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </header>
                <div className={`wrapResponsiveNav ${active ? 'active' : ''}`}>
                    <div className={`responsiveNav`}>
                        <div className={`content`}>
                            <div className={`wrapNavSocial`}>
                                <nav>
                                    <ul className={`topMenu`}>
                                        <li>
                                            <span>Québec : <a href="tel:4189079313">418-907-9313</a></span><br /><br />
                                            <span>Brossard : <a href="tel:5143947960">514-394-7960</a></span>
                                        </li>
                                        <li><a href="https://www.facebook.com/Agence-Prolifik-158443841246997/?fref=ts" target="_blank" className={`iconHeader iconFacebook fa fa-facebook`}></a></li>
                                        <li><a href="https://www.instagram.com/agenceprolifik/" target="_blank" className={`iconHeader iconInstagram fa fa-instagram`}></a></li>
                                        <li><a href="https://www.youtube.com/channel/UC6wxgSDqi0di2PoLq-V0zQg" target="_blank" className={`iconHeader iconYoutube fa fa-youtube-play`}></a></li>
                                        <li><a href="https://www.snapchat.com/add/alexlabs02" target="_blank" className={`iconHeader iconSnapchat fa fa-snapchat-ghost`}></a></li>
                                    </ul>
                                </nav>
                                <div className={`cancel ${flipOutX ? '' : 'flipOutX'}`} onClick={() => this.setState({triggerClick: false})}>
                                    <svg id="svgCancel" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enableBackground="new 0 0 40 40">
                                        <rect className={`bar`} x="-4.5" y="16.5" transform="matrix(0.7071 0.7071 -0.7071 0.7071 19.9999 -8.2844)" fill="#FFFFFF" width="49" height="7"/>
                                        <rect className={`bar`} x="-4.5" y="16.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -8.2844 20.0001)" fill="#FFFFFF" width="49" height="7"/>
                                    </svg>
                                </div>
                            </div>
                            <div className={`wrapBtnMenu`}><Link to="/contact" onClick={() => this.setState({triggerClick: false})} className={`btnMenu`}>Planifier votre consultation gratuite</Link></div>
                            <div className={`wrapMainNav`} role="navigation">
                                <nav>
                                    <ul>
                                        <li><Link to="/agence" onClick={() => this.setState({triggerClick: false})}>Agence</Link></li>
                                        <li><Link to="/approche" onClick={() => this.setState({triggerClick: false})}>Approche</Link></li>
                                        <li>
                                            <span className={`noLinkMenu`} onClick={() => this.ClickSubMenu()}>Expertise</span>
                                            <div className={`wrapSubMenu`}>
                                                <ul className={`subMenu`}>
                                                    <li><Link to="/strategie-web" onClick={() => this.setState({triggerClick: false})}>Stratégie web</Link></li>
                                                    <li><Link to="/developpement-web" onClick={() => this.setState({triggerClick: false})}>Développement Web</Link></li>
                                                    <li><Link to="/service-conseil" onClick={() => this.setState({triggerClick: false})}>Service conseil</Link></li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li><Link to="/realisations" onClick={() => this.setState({triggerClick: false})}>Réalisations</Link></li>
                                        <li><Link to="/blogue" onClick={() => this.setState({triggerClick: false})}>Blogue</Link></li>
                                        <li><Link to="/contact" onClick={() => this.setState({triggerClick: false})}>Contact</Link></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./components/Header/Header.js